var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11376 24.03L0.500014 25.5L1.97001 18.8862C1.00193 17.0755 0.496923 15.0533 0.500014 13C0.500014 6.09625 6.09626 0.5 13 0.5C19.9038 0.5 25.5 6.09625 25.5 13C25.5 19.9037 19.9038 25.5 13 25.5C10.9467 25.5031 8.92453 24.9981 7.11376 24.03ZM7.47626 21.3888L8.29251 21.8263C9.7407 22.6002 11.358 23.0034 13 23C14.9778 23 16.9112 22.4135 18.5557 21.3147C20.2002 20.2159 21.4819 18.6541 22.2388 16.8268C22.9957 14.9996 23.1937 12.9889 22.8079 11.0491C22.422 9.10929 21.4696 7.32746 20.0711 5.92893C18.6726 4.53041 16.8907 3.578 14.9509 3.19215C13.0111 2.8063 11.0004 3.00433 9.17318 3.7612C7.34592 4.51808 5.78413 5.79981 4.68532 7.4443C3.5865 9.08879 3.00001 11.0222 3.00001 13C3.00001 14.6675 3.40626 16.2725 4.17501 17.7075L4.61126 18.5238L3.79251 22.2075L7.47626 21.3888ZM6.75001 13H9.25001C9.25001 13.9946 9.6451 14.9484 10.3484 15.6517C11.0516 16.3549 12.0055 16.75 13 16.75C13.9946 16.75 14.9484 16.3549 15.6517 15.6517C16.3549 14.9484 16.75 13.9946 16.75 13H19.25C19.25 14.6576 18.5915 16.2473 17.4194 17.4194C16.2473 18.5915 14.6576 19.25 13 19.25C11.3424 19.25 9.7527 18.5915 8.5806 17.4194C7.40849 16.2473 6.75001 14.6576 6.75001 13Z",
    fill: "#101820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/hello.4fadfca13ee3fcd2b840ecf47c1c4a38.svg";
export { ForwardRef as ReactComponent };